/* Состояние вкладки «Озвучка». Список в колонке — виджет voice-list, его рисует React.
   Каркас отдаёт свои замыкания через bind. Правая панель и «Другой голос» ставят тот же виджет сами. */

import { uiText } from '../../i18n';
import { createVoiceList, type VoiceCommit, type VoiceListOpts } from './voice-list';

export interface TtsPicker {
  state: {
    value?: unknown; tab?: string; coll?: string | null; q?: string; top?: number; shown?: number; playing?: unknown;
    only?: 's2s' | ''; note?: { text: string; kind?: 'mute' | 'ok' } | null;
  };
  render(): void;
  refresh?(delay?: number): void;
  requery?(delay?: number): void;
  destroy(): void;
}

export interface TtsDeps {
  $: (id: string) => HTMLElement | null;
  S: { tts: { voice: number | null; pst: TtsPicker['state'] | null } };
  pickerOpts: (extra: object, mineBtn?: string | (() => string)) => object;
  pkFast: (el: HTMLElement, pk: TtsPicker) => void;
  pickerAfter: (e: Event) => void;
  syncSeg: (show?: boolean, el?: Element | null) => void;
  maybeHint: (force?: boolean, kind?: string) => void;
}

let deps: TtsDeps | null = null;
let picker: TtsPicker | null = null;
let commitHtml: VoiceCommit | null = null;

/** Куда колонка React кладёт разметку виджета. Ставится до attachTts */
export function setVoiceCommit(fn: VoiceCommit | null) {
  commitHtml = fn;
}

export function bindTts(d: TtsDeps) {
  deps = d;
}

export function getPicker() {
  return picker;
}

/** Запомнить прокрутку и число строк перед уходом с вкладки */
export function captureTts() {
  if (!picker || !deps) return;
  const st = picker.state;
  const sc = deps.$('vscroll');
  const n = document.querySelectorAll('#vl .v').length;
  if (sc && sc.offsetParent !== null) st.top = sc.scrollTop;
  if (n > 14) st.shown = n;
}

/** Снять выбор голоса вкладки. Повторный вызов ничего не делает */
export function destroyTts() {
  if (!picker) return;
  captureTts();
  picker.destroy();
  picker = null;
}

/** Поставить выбор голоса в колонку #vp. Слушатель — после слушателя компонента: вкладка уже переключена */
export function attachTts() {
  if (!deps) throw new Error('Озвучка: каркас не передал выбор голоса');
  if (!commitHtml) throw new Error('Озвучка: колонка ещё не готова принять список');
  const el = deps.$('vp');
  if (!el) throw new Error('Озвучка: нет колонки #vp');
  destroyTts();
  const commit = commitHtml;
  picker = createVoiceList(
    deps.pickerOpts(
      { el, value: deps.S.tts.voice, state: deps.S.tts.pst },
      () => `<a class="btn sm" href="#clone">${window.SteosUI.icons.mic}${uiText('Клонировать голос')}</a>`,
    ) as VoiceListOpts,
    commit,
  );
  deps.S.tts.pst = picker.state;
  deps.pkFast(el, picker);
  el.addEventListener('click', deps.pickerAfter);
  deps.syncSeg(true);
  deps.maybeHint();
}
